module.exports = __webpack_public_path__ + "static/media/features-image-hotspot.5346e93e.png";